export default __webpack_public_path__ + "static/media/fee-white.2fa3693b.svg";